module.exports = __webpack_public_path__ + "img/calendar-25.7b39b557.svg";